import { useLocation } from "react-router-dom";

const useInvoices = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get("activeTab") || "pending";
  const isPending = activeTab === "pending";

  const tabNavs = [
    {
      label: "Pending",
      title: "Pending",
      link: `/orders/delivery/invoices?activeTab=pending`,
      active: activeTab === "pending",
    },
    {
      label: "Completed",
      title: "Completed",
      link: `/orders/delivery/invoices?activeTab=completed`,
      active: activeTab === "completed",
    },
  ];

  return { activeTab, isPending, tabNavs };
};

export default useInvoices;
